<template>
  <div>
    <div v-if="evento.foto">
    <v-img :src="$store.state.baseurl+'/api/image/'+evento.foto.id+'/'" contain></v-img>
    <v-list class="mt-5" v-if="evento && evento.files.length > 0">
      <v-list-item-group color="primary">
        <b>{{$t('Archivos adicionales')}}</b>
        <v-list-item-content>
          <v-list-item-title v-for="f in evento.files" @click="">
            <a :href="$store.state.baseurl+'/api/downloads/'+f.id">{{f.nombre}}</a>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item-group>
    </v-list>
    </div>
  </div>
</template>

<script>
    export default {
        name: "Pic",
        props: {
            evento: Object
        },
        data() {
            return {};
        }
    }
</script>